import React from "react";
import styles from "./index.module.scss";
import SectionContent from "@src/components/SectionContent";
import Button from "@src/components/Button";
import { RepuationLink } from "@src/constant/navLinks";


export default () => {
  const onLaunch = () => {
    // if (!isDesktop()) {
    //   alert("Please use the PADO Extension from the Chrome website platform.");
    //   return 
    // }
    // var specialEl = document.querySelector("#pado-extension-inject-el");
    // if (specialEl) {
    //   window.postMessage(
    //     {
    //       target: "padoExtension",
    //       name: "event",
    //       params: {
    //         eventName: "",
    //         methodName: "createTab",
    //         path: "home.html#/home",
    //       },
    //     },
    //     "*"
    //   );
    // } else {
      window.open(RepuationLink);
    // }
  };
  return (
    <div className={styles.root}>
      <div className={styles.body}>
        <h1 className={styles.title}>
        Bringing all internet data into smart contracts
        </h1>
        <SectionContent className={styles.content}>
          Verify and prove any internet data with zkTLS. Transform off-chain web data and user actions into cryptographically verifiable attestations.
        </SectionContent>
        <Button isDark className={styles.btn} onClick={onLaunch}>
        Join AlphaNet
        </Button>
      </div>

      <div className={styles.cover} />
    </div>
  );
};
